import { defineComponent as _defineComponent } from 'vue'
import ColumnsGroup from "@/components-UI/table/columns/ColumnsGroup.vue";
import { IColumnsGroup } from "@/utils/ColumnsCreator";

interface Props {
    columns: IColumnsGroup[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnsList',
  props: {
    columns: null
  },
  setup(__props: any) {

const props = __props as {
    columns: IColumnsGroup[];
}




return { __sfc: true,props, ColumnsGroup }
}

})